import { render, staticRenderFns } from "./Footer-co.vue?vue&type=template&id=5b7f6c03"
import script from "./Footer-co.vue?vue&type=script&lang=js"
export * from "./Footer-co.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports